/**
 * TIP Shell — origin map (single source of truth), fetched from the Shell server at
 * /config.json. Nothing hard-codes origins (spike pattern). Three origins are
 * non-negotiable for isolation (SCAFFOLD §6): SHELL (this trusted parent),
 * SANDBOX (the distinct opaque sealed-frame origin), API (the backend monolith).
 */
export interface ShellConfig {
  SHELL_ORIGIN: string;
  SANDBOX_ORIGIN: string;
  API_ORIGIN: string;
}

export async function loadConfig(): Promise<ShellConfig> {
  const r = await fetch('/config.json', { cache: 'no-store' });
  if (!r.ok) throw new Error(`config.json → HTTP ${r.status}`);
  const c = (await r.json()) as Partial<ShellConfig>;
  if (!c.SHELL_ORIGIN || !c.SANDBOX_ORIGIN || !c.API_ORIGIN) {
    throw new Error('config.json missing SHELL_ORIGIN / SANDBOX_ORIGIN / API_ORIGIN');
  }
  return { SHELL_ORIGIN: c.SHELL_ORIGIN, SANDBOX_ORIGIN: c.SANDBOX_ORIGIN, API_ORIGIN: c.API_ORIGIN };
}
